import React from "react";
import { Card, Divider } from "antd";
import { USABLE_ICONS, MODULE_APPROVAL_REWARDS } from "variables/constants";
import ApprovalButtons from "components/button/approvalbuttons";
import RewardApprovalForm from "../../approval-rewards/components/RewardApprovalForm";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const NominationCard = ({ recordList }) => {
  const authUser = useSelector((state) => state.auth.user);

  return (
    <>
      {recordList?.map((item) => {
        const colorClass = item?.reward_color_class?.toLowerCase();

        const IconComponent =
          item?.reward_icon && USABLE_ICONS[item?.reward_icon]
            ? USABLE_ICONS[item?.reward_icon]
            : null;


        return (
          <Card
            key={item?.erw_id}
            className={`rounded-2xl overflow-y-auto pr-2 mb-2 nomination dark-mode-card ${colorClass || ""}`}
          >
            <div className="relative flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
              <span
                  className={`absolute top-0 right-0 sm:right-5 text-white p-2 icon-style ${colorClass || ""}`}
              >
                {IconComponent &&
                  React.createElement(IconComponent, {
                    className: "h-5 w-5"
                  })}
                  
              </span>

              <div className="flex items-start gap-3 min-w-0 pr-20">

                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-semibold">
                  {item?.employee_initials}
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">

                    <h4 className="font-semibold text-base title-text break-words">
                      {item?.employee_name}
                    </h4>

                    <span className="status-indicator normal text-[10px] muted-text">
                      {item?.employee_code}
                    </span>

                    <span className={`status-indicator ${item?.erw_status_name.toLowerCase()} text-[10px] px-2`}>
                      {item?.erw_status_name}
                    </span>

                  </div>

                  <p className="text-gray-600 text-[13px]">
                    Nominated by: {item?.nominator_name}
                  </p>
                </div>
              </div>
            </div>

            <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

            <div className="grid grid-cols-3 gap-4 mt-2">
              <div className="col-span-3 md:col-span-1">
                <p className="text-base mb-1 muted-text">
                  Reward Category
                </p>
                <div className="text-base font-medium title-text">
                  {item?.reward_title}
                </div>
              </div>

              <div className="col-span-3 md:col-span-1">
                <p className="text-base mb-1 muted-text">
                  Reward Points
                </p>
                <div className="text-base font-medium title-text">
                  {item?.erw_points_awarded}
                </div>
              </div>

              <div className="col-span-3 md:col-span-1">
                <p className="text-base text-gray-500 mb-1">
                  Nomination Date
                </p>
                <div className="text-base font-medium title-text">
                  {item?.erw_issued_at
                    ? dayjs(item.erw_issued_at).format("MMMM D, YYYY")
                    : "-"}
                </div>
              </div>
              {item?.erw_status_name?.toLowerCase() === 'pending' && 
                !authUser?.client_id && (
                <div className="mt-6 col-span-1 col-start-3">
                  <ApprovalButtons
                    record={item}
                    recordIdKey="erw_id"
                    employeeNameKey="employee_name"
                    moduleId={MODULE_APPROVAL_REWARDS} 
                    FormComponent={RewardApprovalForm}
                    modalPrefix="edit_nomination"
                  />
                </div>
              )}
            </div>
          </Card>
        );
      })}
    </>
  );
};

export default NominationCard;